<template>
  <div class="d-flex flex-fill w-100 h-100 flex-column"
       :class="{ 'justify-content-center align-items-center': !assignment }">
    <button type="button" class="close-assignment position-absolute" @click="$emit('close')" data-bs-dismiss="modal"
            aria-label="Close" v-if="!assignment"><span>+</span></button>
    <div class="spinner-border" role="status" v-if="!assignment">
      <span class="visually-hidden">Loading...</span>
    </div>
    <template v-else>
      <div class="asm-head">
        <h5 class="text-bold px-3 m-0">{{ assignment.name }}</h5>
        <div class="d-flex gap-3">
          <div class="asm-desc d-flex align-items-center gap-3">
            <div class=" d-flex flex-column">
              <h5 class="desc-title">{{ `${$t('status')}:` }}</h5>
              <p class="desc-content status" :class="assignment.state_submissions.status">
                {{ $t(assignment.state_submissions.status) }}</p>
            </div>
            <div class=" d-flex flex-column" v-if="assignment.total_submission > 0">
              <h5 class="desc-title">{{ `${$t('attempts')}:` }}</h5>
              <p class="desc-content">{{
                  assignment.state_submissions.total_submission
                }}<span>{{ `/${assignment.total_submission}` }}</span></p>
            </div>
            <div class=" d-flex flex-column">
              <h5 class="desc-title">{{ `${$t('teacher')}:` }}</h5>
              <p class="desc-content">{{ assignment.teacher }}</p>
            </div>
            <div class=" d-flex flex-column">
              <h5 class="desc-title">{{ `${$t('due_date')}:` }}</h5>
              <p class="desc-content">{{ moment.unix(assignment.end_time).format('DD/MM/YYYY HH:mm') }}</p>
            </div>
          </div>
          <div class="d-flex">
            <template v-if="['draft', 'to_do'].includes(assignment.state_submissions.status)">
              <button type="button" class="assignment-button ito-btn-success text-capitalize"
                      @click="saveAssignment('draft')">{{ $t('save_draft') }} <i class="ito-icon ito-icon-save"></i>
              </button>
            </template>

            <template v-if="['draft', 'to_do'].includes(assignment.state_submissions.status)">
              <button type="button" class="assignment-button ito-btn-secondary text-capitalize"
                      @click="saveAssignment('submitted')" :disabled="totalAnswer == 0">
                {{ $t('submit') }}
                <i class="ito-icon ito-icon-submit"></i>
              </button>
            </template>

            <template
                v-if="assignment.state_submissions.status == 'submitted' && assignment.state_submissions.total_submission < assignment.total_submission && moment().isBefore(moment.unix(assignment.end_time))">
              <button type="button" class="assignment-button ito-btn-secondary text-capitalize"
                      @click="redoAssignment()">
                {{ $t('redo') }}
                <i class="ito-icon ito-icon-reload"></i>
              </button>
            </template>

            <template v-if="assignment.state_submissions.status == 'completed'">
              <button type="button" class="assignment-button ito-btn-result text-capitalize"> {{ $t('asm_point') }}:
                <span>{{ submissionPointFormat(assignment.state_submissions.point) }}</span></button>
            </template>
            <button type="button" class="close-assignment" @click="$emit('close')" data-bs-dismiss="modal"
                    aria-label="Close"><span>+</span></button>
          </div>
        </div>
      </div>
      <div class="asm-body " v-if="assignment.questions.length">
        <transition name="fade" mode="out-in">
          <component v-bind:is="question.question_type" :question="question" :assignment="assignment" @answer="answer" :show_answer="assignment.show_answer"
                     :key="question.id"></component>
        </transition>
        <QuestionPallette :question="question" :questions="assignment.questions" @changeQuestion="changeQuestion"
                          @next="next()"></QuestionPallette>
      </div>
    </template>
  </div>
</template>
<script>
import QuestionPallette from './components/QuestionPallette';
import {getAssignment2, submitAssignment2} from "../../models/assignment";
import {ErrorModal, ConfirmDialogue} from '../modal';
import QuestionMultipleChoice from './QuestionMultipleChoice';
import QuestionLongAnswer from './QuestionLongAnswer';
import QuestionGapFilling from './QuestionGapFilling';

export default {
  name: "AssignmentDetail",
  components: {
    ErrorModal,
    ConfirmDialogue,
    QuestionPallette,
    'mcq': QuestionMultipleChoice,
    'long_answer': QuestionLongAnswer,
    'gap': QuestionGapFilling,
  },
  props: ['assignment_id'],
  data() {
    return {
      assignment: undefined,
      question: undefined,
      answers: [],
      errors: {
        items: undefined
      },
      totalAnswer: 0,
    };
  },

  computed: {
    isAllQuestionsAnswered() {
      return this.assignment.questions.every(question => {
        if (question.question_type === 'long_answer') {
          if (question.submit_type != null) {
            var result = false
            if (question.submit_type.includes('file_submit')) {
              result = question.submissions.files && question.submissions.files.length > 0;
            }
            if (question.submit_type.includes("text_entry")) {
              result = question.submissions.answer !== null && (question.submissions.answer !== '' || question.submissions.answer.answer !== '');
            }
            return result;
          }
        } else {
          return question.submissions.answer !== null && question.submissions.answer !== '';
        }
      });
    }
  },
  mounted() {
    this.fetch()
  },

  methods: {
    async fetch() {
      this.$store.commit("setLoading", true);
      try {
        const response = await getAssignment2({assignment_id: this.assignment_id});
        this.$store.commit("setLoading", false);
        if (response.data.code != 0) {
          this.errors['items'] = response.data.msg;
          return;
        }

        const items = response.data.results;
        if (!items) {
          this.errors.items = 'empty_data';
          return;
        }
        if (!items.questions) {
          this.errors.items = 'no_question_found';
          return;
        }
        let self = this;
        items.questions.forEach(function (e) {
          e.completed = 0;
          if (Array.isArray(e.submissions.answer)) {
            if (e.submissions.answer.filter(e1 => e1.answer != '').length > 0) {

              e.completed = 1;
              self.totalAnswer++;
            }
          }
          if (Array.isArray(e.submissions.files)) {
            if (e.submissions.files.filter(e1 => e1 != '').length > 0) {
              e.completed = 1;
              self.totalAnswer++;
            }
          }
        })
        this.assignment = items;

        this.mapAnswers(items);
        this.question = items.questions[0];
      } catch (error) {
        this.$store.commit("setLoading", false);
        this.errors['items'] = error.message || 'An error occurred';
      }
    },

    submissionPointFormat(value) {
        if (!value || isNaN(value)) return 0;
        return parseFloat(value.toFixed(2));
    },

    mapAnswers(assignment) {
      this.answers = assignment.questions.map(question => {
        let result = {
          question_id: question.id,
          answer: question.submissions.answer?.map(answer => {
            return answer.answer || []
          }),
          question_type: question.question_type
        };

        if (question.question_type === 'long_answer' && question.submit_type?.includes('file_submit')) {
          result['file_ids'] = question.submissions.files?.map(file => file.id);
        }
        return result;
      })
    },

    changeQuestion(question) {
      this.question = question
    },

    answer(question_id, answer) {
      this.question.completed = 0;
      const index = this.answers.findIndex(answer => answer.question_id === question_id);
      if (this.question.question_type === 'long_answer' && this.question.submit_type.includes('file_submit')) {
        this.answers[index].file_ids = this.question.submissions.files?.map(file => file.id);
        if (this.question.submissions.files != null && this.question.submissions.files.length > 0) {
          this.question.completed = 1;
        }
      }
      this.answers[index].answer = answer.map(answer => answer.answer);
      this.assignment.questions.find(q => {
        if (q.id === question_id) {
          if ((q.question_type == 'long_answer' && !q.submit_type.includes('file_submit')) || q.question_type != 'long_answer') {
            q.completed = 0;
          }

          q.submissions.answer = answer;

          if (answer.filter(e => e.answer != '' && e.answer != undefined).length > 0) {
            q.completed = 1;

          }
        }
      });
      let self = this;
      self.totalAnswer = 0;
      this.answers.forEach(function (e) {
        if (e.question_type === 'long_answer') {
          if (e.file_ids != undefined && e.file_ids != null && e.file_ids.length > 0) {
            self.totalAnswer++;
          }
          if (Array.isArray(e.answer)) {
            if (e.answer.filter(e1 => e1 != '' && e1 != undefined).length > 0) {
              self.totalAnswer++;
            }
          }

        } else {
          if (Array.isArray(e.answer)) {
            if (e.answer.filter(e1 => e1 != '' && e1 != undefined).length > 0) {
              self.totalAnswer++;
            }
          }
        }
      })
    },
    redoAssignment() {
      this.$swal({
        title: this.$t('confirm_redo_assignment_title'),
        text: this.$t('confirm_redo_assignment_content'),
        showCloseButton: true,
        closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
        showCancelButton: true,
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no'),
        reverseButtons: true,
        customClass: {
          title: 'fs-5 text-body',
          actions: 'd-flex gap-3',
          confirmButton: 'ito-btn ito-btn-primary',
          cancelButton: 'ito-btn ito-btn-outline-primary',
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.assignment.state_submissions.status = 'draft'
        }
      });

    },

    async saveAssignment(type) {
      if (type === 'draft') {
        await this.submit(type);
      } else if (type === 'submitted') {
        var text = this.$t('confirm_submit_assignment_content');
        if (this.totalAnswer < this.assignment.questions.length) {
          text = this.$t('not_answer_submit')
        }
        this.$swal({
          title: this.$t('confirm_submit_assignment_title'),
          text: text,
          showCloseButton: true,
          closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
          reverseButtons: true,
          width: '37em',
          customClass: {
            title: 'fs-5 text-body',
            actions: 'd-flex gap-3',
            confirmButton: 'ito-btn ito-btn-primary',
            cancelButton: 'ito-btn ito-btn-outline-primary',
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.submit(type);
          }
        });
      }
      return;
    },

    async submit(type) {
      const payload = {
        assignment_id: this.assignment.id,
        answers: JSON.stringify(this.answers),
        save_type: type,
      };
      this.$store.commit("setLoading", true);
      try {
        const {data} = await submitAssignment2(payload);
        this.$store.commit("setLoading", false);
        if (data.code !== 0) {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(data.msg),
            showCloseButton: true,
            closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
            showConfirmButton: false,
            customClass: {
              title: 'fs-5 text-body',
              width: '33em',
            },
          });
        } else {
          this.$emit('reload');
          $('.modal').modal('hide')
          switch (type) {
            case 'draft':
              this.$swal({
                title: this.$t('save_draft_assignment_title'),
                text: this.$t('save_draft_assignment_content'),
                showCloseButton: true,
                closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
                showConfirmButton: false,
                customClass: {
                  title: 'fs-5 text-body',
                },
              });
              break;
            case 'submitted':
              this.$swal({
                title: this.$t('success'),
                text: this.$t('submited_assignment_content'),
                showCloseButton: true,
                closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
                showConfirmButton: false,
                customClass: {
                  title: 'fs-5 text-body',
                },
              });
              break;
            default:
              break;
          }
        }
      } catch (error) {
        this.$store.commit("setLoading", false);
        console.error(error.response);
      }
    }
  }
}
</script>

<style scoped>
.asm-head {
  height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}

.asm-body {
  display: flex;
  height: calc(100% - 52px);
}

.close-assignment {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  width: 52px;
  height: 52px;
  background: #F04821;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  border: 0;
}

.close-assignment:hover {
  background: #f04721bc;

}

.close-assignment span {
  display: flex;
  width: 26px;
  height: 26px;
  background: #ffffff;
  color: #f04821;
  font-size: 26px;
  line-height: 26px;
  font-weight: bold;
  border-radius: 100%;
  transform: rotate(45deg);
  align-items: center;
  justify-content: center;
}

.assignment-button {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  height: 52px;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  border: 0;
  gap: 5px;
}

.assignment-button:disabled,
.assignment-button:disabled:hover {
  background: #ACACAC !important;
  color: var(--white) !important;
  box-shadow: none !important;
  cursor: not-allowed;
}

.asm-desc .desc-title {
  font-size: 12px;
  font-weight: 400;
  color: #1B1B1B;
}

.asm-desc .desc-content {
  font-size: 14px;
  font-weight: 700;
  color: #1B1B1B;
}

.asm-desc .desc-content span {
  font-size: 12px;
  color: #ACACAC;
}

.asm-desc .desc-content.status::before {
  content: '•';
  margin-right: 5px;
}

.asm-desc .desc-content.to_do {
  color: #A35CDB;
}

.asm-desc .desc-content.draft {
  color: #F48D40;
}

.asm-desc .desc-content.submitted {
  color: #1FB4FF;
}

.asm-desc .desc-content.completed {
  color: #98C923;
}

.asm-desc .desc-content.over_due {
  color: #444444;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>